module.exports = __webpack_public_path__ + "static/media/notification-icon.172dba78.png";